<template>
	<nuxt-link-enhance
		class="box-border flex items-center px-4 py-3 bm-size-3_5 leading-6 cursor-pointer hover:bm-bg-gray-100"
		:to="`/messages${item.stationType ? `?type=${item.stationType}` : ''}`"
		:project="PROJECT_MAP.MASTER"
		exact
	>
		<div :class="$style.Clazz__Col">
			<div :class="$style.Clazz__Row">
				<span :class="[$style['Clazz__Row--text'], $style['Clazz__Title']]">{{ item.msgClassName }}</span>
				<span :class="$style.CountDot" v-if="item.unreadCount > 0">{{
					`${item.unreadCount > 99 ? `99+` : `${item.unreadCount}`}`
				}}</span>
			</div>
			<div :class="$style.Clazz__Row" style="margin-top: 4px" v-if="item.title">
				<span :class="[$style['Clazz__Row--text'], $style['Clazz__Content']]"> {{ item.title }}</span>
				<span :class="$style.Clazz__Time"> {{ formatTime(item.pushTime) }}</span>
			</div>
		</div>
	</nuxt-link-enhance>
</template>
<script lang="ts">
import NuxtLinkEnhance from '@/frontend-shared/components/NavigatorBar/components/NuxtLinkEnhance.vue';
import moment from 'moment';
import { PROJECT_MAP } from '../../config';
export default {
	layout: 'main-new',
	components: {
		NuxtLinkEnhance,
	},
	props: {
		item: {
			type: Object,
			default: () => {},
		},
	},
	setup() {
		const formatTime = (time: number) => {
			const today = moment().format('YYYY-MM-DD');
			const currentSp = moment(time).format('YYYY-MM-DD HH:mm').split(' ');
			if (today === currentSp[0]) {
				// 是同一天
				return currentSp[1];
			} else {
				return currentSp[0];
			}
		};
		return {
			formatTime,
			PROJECT_MAP
		};
	},
};
</script>
<style lang="less" module>
.Clazz {
	&__Title {
		font-size: 16px;
		font-weight: 500;
		color: #1a1b1f;
	}
	&__Content {
		font-size: 14px;
		font-weight: 400;
		color: #6a7c81;
		line-height: 18px;
	}
	&__Time {
		font-size: 12px;
		font-weight: 400;
		color: #aab7bd;
		line-height: 18px;
	}
	&__Col {
		display: flex;
		width: 100%;
		flex-direction: column;
		min-height: 48px;
		align-items: center;
		justify-content: center;
		padding: 0 4px;
		box-sizing: border-box;
	}
	&__Row {
		display: flex;
		width: 100%;
		align-items: center;
		&--text {
			max-lines: 1;
			overflow: hidden;
			white-space: nowrap;
			text-overflow: ellipsis;
			flex: 1;
			padding-right: 20px;
		}
	}
}
.CountDot {
	display: block;
	color: #ffffff;
	background-color: #ff532f;
	border-radius: 30px;
	line-height: 12px;
	font-size: 10px;
	padding: 1px 5px;
	min-width: 24px;
	text-align: center;
	box-sizing: border-box;
	height: 14px;
}
</style>
